import React, { useEffect } from 'react'
import { MuvicardService } from '../../../../services/muvicard.service'
import {
	PasswordHeader,
	PasswordSection,
	ContainerPassword
} from '../../styles.style'

const Password = ({
	paymentDay,
	passwordCard,
	setPasswordCard,
	setStep,
	prevStep,
	cardInfo
}) => {
	useEffect(() => {
		MuvicardService.proposalStepRegister('Senha', 'Acesso')
	}, [])

	function handleChange(e) {
		const re = /^[0-9\b]+$/
		if (e.target.value === '' || re.test(e.target.value)) {
			setPasswordCard(e.target.value)
		}
	}

	function countCharacters(e) {
		if (e.target.value.length === 4) {
			// go next step
			setStep(9)
		}
	}

	function back() {
		setPasswordCard('')
		prevStep()
	}

	return (
		<ContainerPassword>
			<PasswordHeader>
				<h4>
					Certo! <br />A data de vencimento de sua fatura ficou para todo o{' '}
					<span>dia {paymentDay}</span>
				</h4>
			</PasswordHeader>
			<PasswordSection>
				<div>
					<p>
						Agora você precisa definir <br /> uma senha para seu cartão
					</p>
				</div>
				<div>
					<input
						autoFocus
						pattern="[0-9]*"
						placeholder="****"
						autoComplete="off"
						type="password"
						maxLength="4"
						name="passwordcard"
						value={passwordCard}
						onChange={e => handleChange(e)}
						onKeyUp={e => countCharacters(e)}
					/>
				</div>
			</PasswordSection>

			<footer className="footer">
				<button
					className="button transparent"
					type="button"
					onClick={() => back()}>
					Voltar
				</button>
			</footer>
		</ContainerPassword>
	)
}

export default Password
